<template>
    <main-template>
      <abstract-submission-receipt
        class="self"
        :header="'termsAndConditions.reviewSubmission.networkError.header'"
        :reason="'termsAndConditions.reviewSubmission.networkError.reason'"
        :title="'termsAndConditions.reviewSubmission.networkError.title'">
        <div @click="handleReturnConfirmation" >{{ $t('termsAndConditions.reviewSubmission.networkError.highLight')}}</div>
      </abstract-submission-receipt>
    </main-template>
</template>

<script lang="ts" setup>
    import AbstractSubmissionReceipt from '@/components/reviewSubmission/AbstractSubmissionReceipt.vue'
    import MainTemplate from '@/components/MainTemplate.vue'
    import { useRoute } from 'vue-router'
    import router from '@/router'

    const route = useRoute()
    const handleReturnConfirmation = () => {
        router.push({ name: 'FNOL Review and Submission', params: { visible: 'true' }, query: { data: route.query.data } })
    }
</script>

<style scoped>
.self  {
  margin:auto
}
</style>
